import * as $ from 'jquery';
import formErrors from './form-errors';

// Regular expression used to split event strings.
var eventSplitter = /\s+/;

// A private global variable to share between listeners and listenees.
var _listening;

// The reducing API that adds a callback to the `events` object.
var onApi = function(events, name, callback, options) {
    if (callback) {
        var handlers = events[name] || (events[name] = []);
        var context = options.context, ctx = options.ctx, listening = options.listening;
        if (listening) listening.count++;

        handlers.push({callback: callback, context: context, ctx: context || ctx, listening: listening});
    }
    return events;
};
// Iterates over the standard `event, callback` (as well as the fancy multiple
// space-separated events `"change blur", callback` and jQuery-style event
// maps `{event: callback}`).
var eventsApi = function(iteratee, events, name, callback, opts) {
    var i = 0, names;
    if (name && typeof name === 'object') {
        // Handle event maps.
        if (callback !== void 0 && 'context' in opts && opts.context === void 0) opts.context = callback;
        for (names = _.keys(name); i < names.length ; i++) {
            events = eventsApi(iteratee, events, names[i], name[names[i]], opts);
        }
    } else if (name && eventSplitter.test(name)) {
        // Handle space-separated event names by delegating them individually.
        for (names = name.split(eventSplitter); i < names.length; i++) {
            events = iteratee(events, names[i], callback, opts);
        }
    } else {
        // Finally, standard events.
        events = iteratee(events, name, callback, opts);
    }
    return events;
};
// Handles triggering the appropriate event callbacks.
var triggerApi = function(objEvents, name, callback, args) {
    if (objEvents) {
        var events = objEvents[name];
        var allEvents = objEvents.all;
        if (events && allEvents) allEvents = allEvents.slice();
        if (events) triggerEvents(events, args);
        if (allEvents) triggerEvents(allEvents, [name].concat(args));
    }
    return objEvents;
};
// A difficult-to-believe, but optimized internal dispatch function for
// triggering events. Tries to keep the usual cases speedy (most internal
// Backbone events have 3 arguments).
var triggerEvents = function(events, args) {
    var ev, i = -1, l = events.length, a1 = args[0], a2 = args[1], a3 = args[2];
    switch (args.length) {
        case 0: while (++i < l) (ev = events[i]).callback.call(ev.ctx); return;
        case 1: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1); return;
        case 2: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2); return;
        case 3: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2, a3); return;
        default: while (++i < l) (ev = events[i]).callback.apply(ev.ctx, args); return;
    }
};

var SelectAddable = function($button, select_class, format_data_function, format_filter_function)
{
    this.$button = $button;
    this.selectClass = select_class;
    this.formatData = format_data_function;
    this.formatFilter = format_filter_function;
    this.init();
};

SelectAddable.prototype.init = function()
{
    this.$container = this.$button.closest('div.form-group');
    this.$modal = this.$container.find('div.modal');
    this.setupEvents();
};

SelectAddable.prototype.getFormData = function($inputs)
{
    var data = {};
    $inputs.each(function() {
        var name = $(this).attr('name');

        if (name)
        {
            var val = $(this).val();
            name = name.replace('popup_', '');
            data[name] = val;
        }

    });
    return data;
};

SelectAddable.prototype.setupEvents = function()
{
    var self = this;
    this.$button.on('click', function(e) {
        e.preventDefault();
        self.$modal.modal('show');
    });

    this.$modal.on('click', 'button.modal-save', function(e) {

        if (!self.running) {
            self.running = true;
            var $modal = self.$modal,
                action = $modal.data('action'),
                $inputs = $modal.find('input,select,textarea');

            $.ajax(action, {
                method: 'POST',
                data: self.getFormData($inputs),
                error: function (error) {
                    var json_errors = error.responseJSON.errors;
                    // Handle form errors
                    formErrors($modal, json_errors);
                },
                success: function (data) {
                    // Trigger an event that can be used to add this to the selects
                    var $option = $('<option>')
                        .val(data.id)
                        .prop('selected', true)
                        .html(self.formatData(data))
                        .data('filter-value', self.formatFilter(data));

                    $('select.' + self.selectClass).each(function () {
                        var $select = $(this);
                        $select.append($option);
                        $select.selectpicker('refresh');
                    });

                    self.trigger('added', data);
                    $modal.modal('hide');
                },
                complete: function() {
                    self.running = false;
                }
            });
        }
    })
};

SelectAddable.prototype.on = function(name, callback, context) {
    this._events = eventsApi(onApi, this._events || {}, name, callback, {
        context: context,
        ctx: this,
        listening: _listening
    });

    if (_listening) {
        var listeners = this._listeners || (this._listeners = {});
        listeners[_listening.id] = _listening;
        // Allow the listening to use a counter, instead of tracking
        // callbacks for library interop
        _listening.interop = false;
    }

    return this;
};

SelectAddable.prototype.trigger = function(name) {
    if (!this._events) return this;

    var length = Math.max(0, arguments.length - 1);
    var args = Array(length);
    for (var i = 0; i < length; i++) args[i] = arguments[i + 1];

    eventsApi(triggerApi, this._events, name, void 0, args);
    return this;
};

export default SelectAddable;

// export default (
//     function()
//     {
//         $('button.location-create-button').on('click', function(e) {
//             e.preventDefault();
//             var $container = $(this).closest('div.form-group'),
//                 $modal = $container.find('div.modal');
//
//             // Open the create location dialog
//             $modal.modal('show');
//         });
//
//         $('div.location-modal').on('click', 'button.location-modal-save', function(e) {
//
//             var $button = $(this),
//                 $container = $(this).closest('div.form-group'),
//                 $select = $container.find('select'),
//                 $modal = $button.closest('div.modal'),
//                 action = $modal.data('action'),
//                 $inputs = $modal.find('input,select,textarea');
//
//             $.ajax(action, {
//                 method: 'POST',
//                 data: $inputs.serialize(),
//                 error: function(error)
//                 {
//                     var json_errors = error.responseJSON.errors;
//                     // Handle form errors
//                     formErrors($modal, json_errors);
//                 },
//                 success: function(data)
//                 {
//                     var $option = $('<option>')
//                         .val(data.id)
//                         .prop('selected', true)
//                         .html(data.name + ', ' + data.city + ', ' + data.country)
//                         .data('filter-value', data.country);
//
//                     $('select.fluffy-control-location').each(function() {
//                         var $select = $(this);
//                         $select.append($option);
//                         $select.selectpicker('refresh');
//                     });
//
//                     $modal.modal('hide');
//                 }
//             });
//         });
//     }($, formErrors)
// );